import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import membershipsReducer from './memberships.reducer';
import purchasesReducer from './purchases.reducer';
import projectionsReducer from './projections.reducer';
import sessionReducer from './session.reducer';
import usersReducer from './users.reducer';
import userPurchasesReducer from './user-purchases.reducer';
import legalDocumentsReducer from './legal-documents.reducer';
import consumerFieldSchemasReducer from './consumer-field-schemas.reducer';
import consumerFieldValuesReducer from './consumer-field-values.reducer';
import uiReducer from './ui.reducer';

export default combineReducers({
  projections: projectionsReducer,
  memberships: membershipsReducer,
  purchases: purchasesReducer,
  users: usersReducer,
  userPurchases: userPurchasesReducer,
  legalDocuments: legalDocumentsReducer,
  consumerFieldSchemas: consumerFieldSchemasReducer,
  consumerFieldValues: consumerFieldValuesReducer,
  session: sessionReducer,
  ui: uiReducer,
  form: formReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js